import colors from "colors";
import { IconProps } from "./types";

export default function IcoRoad({
	color = colors.neutral["low-pure-500"],
	size = "24"
}: IconProps) {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.41561 1.50676C5.68799 1.55216 5.87201 1.80977 5.82661 2.08216L2.49327 22.0822C2.44788 22.3545 2.19026 22.5385 1.91788 22.4932C1.64549 22.4478 1.46148 22.1901 1.50688 21.9178L4.84021 1.91776C4.88561 1.64537 5.14322 1.46136 5.41561 1.50676ZM18.5845 1.50676C18.8569 1.46136 19.1145 1.64537 19.1599 1.91776L22.4933 21.9178C22.5387 22.1901 22.3547 22.4478 22.0823 22.4932C21.8099 22.5385 21.5523 22.3545 21.5069 22.0822L18.1735 2.08216C18.1281 1.80977 18.3122 1.55216 18.5845 1.50676ZM12.0001 2.33329C12.2762 2.33329 12.5001 2.55715 12.5001 2.83329V6.16662C12.5001 6.44277 12.2762 6.66662 12.0001 6.66662C11.7239 6.66662 11.5001 6.44277 11.5001 6.16662V2.83329C11.5001 2.55715 11.7239 2.33329 12.0001 2.33329ZM12.0001 8.99996C12.2762 8.99996 12.5001 9.22381 12.5001 9.49996V14.5C12.5001 14.7761 12.2762 15 12.0001 15C11.7239 15 11.5001 14.7761 11.5001 14.5V9.49996C11.5001 9.22381 11.7239 8.99996 12.0001 8.99996ZM12.0001 17.3333C12.2762 17.3333 12.5001 17.5571 12.5001 17.8333V21.1666C12.5001 21.4428 12.2762 21.6666 12.0001 21.6666C11.7239 21.6666 11.5001 21.4428 11.5001 21.1666V17.8333C11.5001 17.5571 11.7239 17.3333 12.0001 17.3333Z"
				fill={color}
			/>
		</svg>
	);
}
